import { ServiceClient } from 'src/utils'
import { CompanyRow } from './rd_scopes'

const serviceClient = ServiceClient.singleton()


type PjInfoResponse = {
    duration: number
    rows: CompanyRow[]
}

type SyncResponse = {
    duration: number
    updated: string[]
    inserted: string[]
    notfound: string[]
}

export class RdStationService {
    static #INSTANCE = new RdStationService()
    static readonly singleton = () => RdStationService.#INSTANCE

    async fetchCompanyInfos(cnpjs: string[]): Promise<PjInfoResponse> {
        type CompanyInfo = {
            id: string
            razaoSocial: string
            descricaoCnae: string
            website: string
            email: string
            telefone_1: string
            telefone_2: string
            telefone_fax: string
            telefone_google: string
            telefone_serasa: string
        }
        type ResponseType = {
            duration: number
            rows: CompanyInfo[]
        }
        const response = await serviceClient.authPost<ResponseType>('/api/rd-station/pj/info', { cnpjs })

        const data: PjInfoResponse = { 
            duration: response.duration, 
            rows: response.rows.map(info => {
                const telefones: string[] = []
                info.telefone_google && (telefones.push(info.telefone_google))
                info.telefone_serasa && (telefones.push(info.telefone_serasa))
                info.telefone_1 && (telefones.push(info.telefone_1))
                info.telefone_2 && (telefones.push(info.telefone_2))
                info.telefone_fax && (telefones.push(info.telefone_fax))

                const row: CompanyRow = {
                    id: info.id,
                    razaoSocial: info.razaoSocial,
                    descricaoCnae: info.descricaoCnae,
                    website: info.website ?? '',
                    telefone: telefones.join('; '),
                    email: info.email ?? ''
                }

                return row
            })
        }


        return data
    }

    async synchronize(cnpjs: string[]) {
        return serviceClient.authPost<SyncResponse>('/api/rd-station/sync', { cnpjs })
    }
}

export default RdStationService.singleton()
